import { faRefresh, faExclamation, faCheck, faClose, faPen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import "./style.css"

const StatusEquipamento = ({value}) => {
    switch (value) {
        case 0: 
        return (
            <Tooltip title="Em digitação" placement="right">
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faPen} />
                </div>
            </Tooltip>
        )
        case 1: 
        return (
            <Tooltip title="Pendente de homologação" placement="right">
                <div className="status_pendente">
                    <FontAwesomeIcon icon={faRefresh} />
                </div>
            </Tooltip>
        );
        case 2: 
        return (
            <Tooltip title="Revisão necessária" placement="right">
                <div className="status_revisao">
                    <FontAwesomeIcon icon={faExclamation} />
                </div>
            </Tooltip>
        );
        case 3:
        return (
            <Tooltip title="Equipamento homologado" placement="right">
                <div className="status_homologado">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
            </Tooltip>
        );
        case 4: 
        return (
            <Tooltip title="Equipamento cancelado" placement="right">
                <div className="status_cancelado">
                    <FontAwesomeIcon icon={faClose} />
                </div>
            </Tooltip>
        );
        case 6:
        return (
            <Tooltip title="Equipamento homologado" placement="right">
                <div className="status_homologado">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
            </Tooltip>
        );
    }
}

export { StatusEquipamento };